import { Chip, Stack, Typography } from '@montugroup/design-system';
import { useTheme } from '@mui/material';

interface IPrescriptionDosageChip {
  dosage: 'CBD' | 'THC';
  strength: string;
}

export function PrescriptionDosageChip({ dosage, strength }: IPrescriptionDosageChip) {
  const theme = useTheme();

  return (
    <Chip
      variant="outlined"
      color="info"
      label={
        <Stack direction="row" gap={1} alignItems="center">
          <Typography variant="body2" fontWeight={theme.typography.fontWeightMedium}>
            {dosage}
          </Typography>
          <Typography variant="body2">{strength}</Typography>
        </Stack>
      }
    />
  );
}

export default PrescriptionDosageChip;
